import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import sample from "lodash/sample";

import { ImgixNextBackground } from "@components/imgixNextBackground";
import cn from "classnames";

import styles from "./hero.module.css";

export function Hero({
  className = null,
  children = null,
  credit = null,
  height = null,
  overlay = null,
  overlayClasses = null,
  innerRef = null,
  images,
}) {
  const image = useRef(sample(images));

  const { current: hero } = image;

  useEffect(() => {
    image.current = sample(images);
  }, [images]);

  return (
    <section
      className={cn(styles.hero, `relative z-10 ${className}`, {
        "clamp-height": !height,
      })}
      ref={innerRef}
    >
      <figure>
        <ImgixNextBackground
          className={cn(`w-full relative bg-black-400 ${styles["hero-img"]}`, {
            [styles["hero-img-short"]]: height === "short",
          })}
          priority
          src={hero?.url || ""}
          overlay={overlay}
          overlayClasses={overlayClasses}
          imgixParams={{
            q: 60,
            w: 1920,
            h: 1289,
          }}
        >
          {children && children}

          {hero?.credit && credit && (
            <div className={cn("container relative h-full")}>
              <p
                className={cn(
                  "absolute bottom-12 lg:bottom-28 transform -translate-y-4 w-content p-1 m-0 bg-black bg-opacity-80 text-white text-xs leading-tight rounded-sm",
                  {
                    [styles["hero-credit-short"]]: height === "short",
                  }
                )}
              >
                {hero.credit}
              </p>
            </div>
          )}
        </ImgixNextBackground>
      </figure>
    </section>
  );
}

Hero.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      caption: PropTypes.string,
      credit: PropTypes.string,
    })
  ).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  className: PropTypes.string,
  credit: PropTypes.bool,
  height: PropTypes.oneOf(["tall", "short"]),
  overlay: PropTypes.oneOf(["gradient", "full", "custom"]),
  overlayClasses: PropTypes.string,
  innerRef: PropTypes.func,
};
